import React from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

const LoaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(245, 245, 245, 0.95) 100%
  );
  z-index: 1000;
  backdrop-filter: blur(4px);
`;

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

const Spinner = styled.div`
  position: relative;
  width: 50px;
  height: 50px;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 3px solid transparent;
    border-top-color: #cc9900;
    border-right-color: #cc9900;
    border-radius: 50%;
    animation: ${spin} 1.2s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite;
  }

  &::after {
    content: "";
    position: absolute;
    top: 8px;
    left: 8px;
    width: 34px;
    height: 34px;
    border: 2px solid transparent;
    border-bottom-color: rgba(204, 153, 0, 0.4);
    border-left-color: rgba(204, 153, 0, 0.4);
    border-radius: 50%;
    animation: ${spin} 1.8s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite
      reverse;
  }
`;

const LoadingText = styled.div`
  font-size: 14px;
  color: #666;
  font-weight: 500;
  animation: ${pulse} 1.5s ease-in-out infinite;
  letter-spacing: 2px;
`;

const Loader = () => (
  <LoaderContainer>
    <LoaderWrapper>
      <Spinner />
      <LoadingText>Loading</LoadingText>
    </LoaderWrapper>
  </LoaderContainer>
);

export default Loader;
